import { useTranslation } from "react-i18next";
import { getClassNames } from "@/shared/utils";
import { AppButton } from "../AppButton";
import styles from "./styles.module.scss";

type Props = {
  className?: string;
  onClick: () => void;
};

export const SettingsFormSubmitButton = ({ className, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <AppButton type="primary" className={getClassNames(styles.button, className)} onClick={onClick}>
      {t("common.change")}
    </AppButton>
  );
};
